import storage from "redux-persist/lib/storage";
import { encryptTransform } from "redux-persist-transform-encrypt";

const ENCRYPTION_KEY = process.env.REACT_APP_PERSIST_KEY || "default-SecretKey123!";

export const persistConfig = {
  key: "root",
  storage,
  whitelist: ["i18n", "theme", "auth", "setInitConf"], // Slices à persister
  transforms: [
    encryptTransform({
      secretKey: ENCRYPTION_KEY,
      onError: (err) => {
        console.error("Erreur de déchiffrement du store :", err);
      },
    }),
  ],
};
